import { BADGE_TIERS } from '@/lib/reviewBadge';
import MokaPotBadge from '@/components/coffee/MokaPotBadge';
import { Award } from 'lucide-react';

// Ordered bronze → gold for display
const TIERS = [...BADGE_TIERS].sort((a, b) => a.min - b.min);

export default function BadgeInfo() {
  return (
    <section>
      <div className="flex items-center gap-2 mb-4">
        <Award size={16} className="text-primary" strokeWidth={2} />
        <h2 className="font-heading font-semibold text-base">How Badges Work</h2>
      </div>
      <div className="bg-card rounded-2xl border border-border p-5">
        <p className="text-sm text-muted-foreground leading-relaxed mb-4">
          Write reviews to earn Moka Pot badges. The more coffees you review, the higher your rank — shown next to your name across the app.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
          {TIERS.map((tier) => (
            <div
              key={tier.level}
              className="flex items-center gap-3 rounded-xl border border-border bg-secondary/40 px-4 py-3"
            >
              <MokaPotBadge reviewCount={tier.min} size={28} />
              <div>
                <p className="text-sm font-semibold text-foreground">{tier.label}</p>
                <p className="text-xs text-muted-foreground">{tier.min}+ reviews</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}